import { useRequiredParams } from '@pba/react-router';
import { CommunityAboutContent, CommunityLayout } from 'features/communities';

type RoutingParams = {
  communityId: string;
};

export const PageCommunityAbout = () => {
  const { communityId } = useRequiredParams<RoutingParams>();

  return (
    <CommunityLayout
      children={(community) => <CommunityAboutContent community={community} />}
      communityId={communityId}
      tab="/about"
    />
  );
};
